import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.checkliste-aufgabe-bild-ids';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenChecklisteAufgabeBildIdsEffects {

    ChecklisteAufgabeBildIds$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_CHECKLISTE_AUFGABE_BILD_IDS),
        mergeMap((x: ac.GetChecklisteAufgabeBildIdsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getChecklisteAufgabeBildIds(x.checkliste_id, x.aufgabe_id).pipe(
                map((result: any) => {
                    return new ac.GetChecklisteAufgabeBildIdsErfolgreichAction(result, x.checkliste_id, x.aufgabe_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetChecklisteAufgabeBildIdsFehlerAction(error, x.checkliste_id, x.aufgabe_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ChecklisteQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ChecklisteQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ChecklisteQueryService);
        }
        return this.service;
    }
}
